<template>
  <div>
    <v-list subheader>
      <v-subheader class="pa-0">{{$t('sessionLink.guest.information')}}</v-subheader>
      <v-list-item
        v-for="(key, index) in Object.keys(customer)"
        :key="`customer-keys-${index}`"
        class="pa-0"
      >
        <v-list-item-content class="pa-0">
          <v-list-item-title>{{ key }}</v-list-item-title>
          <v-list-item-subtitle>{{ customer[key] }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    customer: {
      type: Object,
      default: null
    }
  }
})
export default class Customer extends Vue {}
</script>
